<div class="masking-section" style="margin-top: 75px;">
    <div class="content">
        <div class="main-action-col">
            <div class="heading">
                <div class="row">
                    <div class="col-sm-5" *ngIf="cam">
                        <div class="header-btn">
                            <a class="back-btn" (click)="goBack()">
                                <mat-icon matTooltip="Back">keyboard_backspace</mat-icon>
                            </a>
                            <div class="d-flex">
                                <div class="header">
                                    <span>Masking Camera</span>
                                    <span class="backdrop-slash">/</span>
                                    <span>{{cam.camUniqueId}}</span>
                                    <span class="backdrop-slash">/</span>
                                    <span>{{cam.camDisplayName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-7">
                        <div class="button-area">
                            <!-- New Button Section -->
                            <div class="mask-btn text-center">
                                <button class="btn btn-sync" matTooltip="Pull Masking Coordinates From Axis Camera" (click)="updateMaskData(cam?.camUniqueId)" [ngClass]="{'disabled': !isAnalyticIdSeven}"  *ngIf="isAnalyticIdSeven && isResolution720p">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                </button>
                                <button class="btn btn-remove" (click)="removeMaskingModal(cam?.camUniqueId)"  
                                *ngIf="pointsFromCamera && isResolution720p " matTooltip="Remove Mask">
                                    <i class="fa fa-trash" aria-hidden="true" style="color: white;"></i>
                                </button>
                            </div>
                            <!-- Existing Buttons -->
                            <div class="mask-btn">
                                <a (click)="showMask()" href="javascript:void(0)">
                                    <button class="btn btn-change" matTooltip="Preview Mask">
                                        <i class="fa fa-eye" aria-hidden="true"></i></button>
                             
                                </a>
                                <button class="btn btn-change" (click)="openChangeMaskingModal(cam?.camUniqueId)"  matTooltip="Change Mask" 
                                *ngIf="pointsFromCamera && isResolution720p">Inverse Mask</button>

                                <a (click)="showImage()" href="javascript:void(0)">
                                    <button class="btn btn-change">Live Image</button>
                                </a>
                            </div>
                            <div class="refresh-section">
                                <a class="mat-raised-button new-btn" (click)="save()"
                                   *ngIf="showBtn && hasEditPrivilege" 
                                   [class.disabled]="pointsFromCamera"
                                   [attr.disabled]="pointsFromCamera ? true : false">Save</a>
                                <!-- <button class="refresh-btn" (click)="reloadImage()">
                                    <mat-icon matTooltip="Refresh">autorenew</mat-icon>
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="sub-heading-section">
            <div class="live-marquee">
                <marquee *ngIf="showMessage"> Any updates to {{intimationMessage}}
                </marquee>
            </div>
        </div> -->
        <div class=" image-zoom">
            <div class="image-area">
                <div class="image-view" [style.min-width.px]="setDynamicImgWidth"
                    [style.height.px]="setDynamicImgHeight">
                    <pan-zoom [config]="panzoomConfig" style="margin: 20px 20px 20px 20px">
                        <div class="artboard" (mouseup)="mouseUp($event)" (mousemove)="mouseMove($event)" #artboard>
                        </div>
                    </pan-zoom>
                </div>
            </div>
            <div class="layer-area" style="height: 500px; width:200px;margin-right:40px;position: absolute;"
                [style.margin-left.px]="actionTableWidth">
                <div class="table-layer-area" *ngIf="svgElement?.children?.length !== 0">
                    <table class="table table-striped table-dark" *ngIf="svgElement!=null"
                    [hidden]="pointsFromCamera ? true : false" >
                        <tr *ngFor="let layer of svgElement.children;index as i">
                            <td class="table-layer">Layer {{i}}</td>
                            <td *ngIf="showBtn">
                                <i (click)="deleteSpLayer(layer)" class="fa fa-trash iocn-layer"></i>
                            </td>
                            <td>
                                <i (click)="highlightSpLayer(layer)" class="fa fa-eye iocn-layer"></i>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal structure -->
<ng-template #changeMaskingModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Change Masking</h4>
      <button type="button" class="closeBtn" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure you want to change the masking?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn  btn-cancel" (click)="modal.dismiss('Cancel click')">Cancel</button>
        <button type="button" class="btn btn-confirm" (click)="confirmChangeMasking()">Confirm</button>
    </div>
  </ng-template>

  <!---remove masking modal-->
  <ng-template #removeMaskingModalRef let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Remove Masking</h4>
      <button type="button" class="closeBtn" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure you want to remove the masking?
    </div>
    <div class="modal-footer">
      <button type="button" class="btn  btn-cancel" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button type="button" class="btn btn-confirm" (click)="removeMasking()">Confirm</button>
    </div>
  </ng-template>